import Modal from 'react-modal'
import { TMapBasicData } from '@/tmapBasicInfo/TMapBasicData'
import { TBoxItemLogic } from '@/tmapBasicInfo/tboxInfo/TBoxItemLogic'

type Props = {
  isOpen: boolean
  basicData: TMapBasicData
  floor: number
  boxIndex: number
  closeModal: () => void
}

const TimeTableModalView = ({ isOpen, basicData, floor, boxIndex, closeModal }: Props) => {
  // #region フック

  const modalStyle = {
    overlay: {
      position: 'fixed' as const,
      top: 0,
      left: 0,
      backgroundColor: 'rgba(240,240,240,0.7)'
    },
    content: {
      position: 'absolute' as const,
      backgroundColor: '#f0f0f0',
      border: 'solid 1px #000000',
      marginRight: 'auto',
      marginLeft: 'auto',
      width: '400px',
      height: '840px',
      padding: '0px'
    }
  }

  const headerStyle: React.CSSProperties = {
    margin: '5px 0px 0px 10px'
  }

  const mainStyle: React.CSSProperties = {
    margin: '0px 10px 10px 10px'
  }

  const infoStyle: React.CSSProperties = {
    lineHeight: '10px'
  }

  const tableAreaStyle: React.CSSProperties = {
    border: 'solid 1px',
    height: '650px',
    overflowY: 'scroll'
  }

  const tableStyle: React.CSSProperties = {
    width: '100%'
  }

  const buttonsStyle: React.CSSProperties = {
    marginTop: '10px',
    textAlign: 'right'
  }

  const secondColumnStyle: React.CSSProperties = {
    width: '160px'
  }

  // #endregion フック

  const head = (
    <thead>
      <tr>
        <th style={secondColumnStyle}>秒数</th>
        <th>宝箱の中身</th>
      </tr>
    </thead>
  )

  const list = []
  for (let i = 6; i <= 300; i++) {
    list.push(
      <tr key={`${basicData.mapRank}-${basicData.mapSeed}-${i}`}>
        <td align='right'>{i}s</td>
        <td>{TBoxItemLogic.calculateTBoxContents(basicData, floor, boxIndex, i)}</td>
      </tr>
    )
  }

  const body = <tbody>{list}</tbody>

  return (
    <Modal isOpen={isOpen} ariaHideApp={false} style={modalStyle}>
      <h1 style={headerStyle}>中断技タイムテーブル</h1>
      <main style={mainStyle}>
        <p style={infoStyle}>
          {basicData.mapName1.name}
          {basicData.mapName2.name}
          {basicData.mapName3.name}
          Lv{basicData.mapLevel}の地図
        </p>
        <p style={infoStyle}>
          B{floor}F 第{boxIndex + 1}箱
        </p>
        <div style={tableAreaStyle}>
          <table border={1} style={tableStyle}>
            {head}
            {body}
          </table>
        </div>
        <div style={buttonsStyle}>
          <button onClick={closeModal}>閉じる</button>
        </div>
      </main>
    </Modal>
  )
}

export { TimeTableModalView }
